import ApiService from "@/core/services/ApiService";
import JwtService from "@/core/services/JwtService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";




export interface User {
 name: string;
 surname: string;
 email: string;
 password: string;
 api_token: string;
}

export interface UserAuthInfo {
 errors: unknown;
 user: User;
 isAuthenticated: boolean;
 isVerified: number ;
}

@Module
export default class AuthModule extends VuexModule implements UserAuthInfo {
 errors = {};
 user = {} as User;
 isAuthenticated = !!JwtService.getToken();
 isVerified = 0;


 /**
  * Get current user object
  * @returns User
  */
 get currentUser(): User {
   return this.user;
 }

 /**
  * Verify user authentication
  * @returns boolean
  */
 get isUserAuthenticated(): boolean {

   return !!JwtService.getToken();
 }
 get isUserVerified(): boolean {

   return !!JwtService.getVERIFIED();
 }

 /**
  * Get authentification errors
  * @returns array
  */
 get getErrors() {
   return this.errors;
 }

 @Mutation
 [Mutations.SET_ERROR](error) {
   this.errors = error;
 }

 @Mutation
 async [Mutations.SET_AUTH]({ data }) {


   this.isAuthenticated = true;


   if (data.verified !== undefined ) {
    this.isVerified = data.verified

  } else if (data?.userData?.UAVERIFIED !== undefined){
    this.isVerified = data.userData.UAVERIFIED

  }else if (data?.userData?.UEVERIFIED !== undefined){
    this.isVerified = data.userData.UEVERIFIED

  };


   this.user = (data.userData) ? data.userData : '';
   // this.errors = [];
   if(data.userData){
    JwtService.saveToken(data.userData.UUID, data.userData.token);
   }else{
     JwtService.saveToken(data.uuid, data.token);
   }
   if(this.isVerified == 1){
     JwtService.saveVerified(this.isVerified);

   }
   else if(data?.userData?.UAVERIFIED !== undefined){

    JwtService.saveVerified(data.userData?.UAVERIFIED);
   }
   else if(data?.userData?.UEVERIFIED !== undefined){
    JwtService.saveVerified(data.userData?.UEVERIFIED);
   }
 }

 @Mutation
 [Mutations.SET_USER](user) {
   this.user = user;
 }

 @Mutation
 [Mutations.SET_PASSWORD](password) {
   this.user.password = password;
 }

 @Mutation
 [Mutations.PURGE_AUTH]() {
   this.isAuthenticated = false;
   this.isVerified = 0;
   this.user = {} as User;
   this.errors = [];
   JwtService.destroyToken();
   JwtService.destroyType();
   JwtService.destroyVerified();
 }

 @Action
 [Actions.LOGIN](credentials) {

  // borrar errores
  this.context.commit(Mutations.SET_ERROR, []);

   const url = credentials.url;
   delete credentials.url;
   delete credentials.type;
   return new Promise((resolve, reject) => {
     ApiService.post(url, credentials)
       .then(({ data } : any) => {

        if(data.data.role != undefined){

          JwtService.saveRole(data.data.role);
        }
         resolve(data);
         if(data.data.mostrarMensaje == 1){
           this.context.commit(Mutations.SET_ERROR, [data.data.mostrarMensaje, data.message]);
           reject(data);
         }else{
           (url.includes('/userLogin')) ? JwtService.saveType('AGENCIA') : JwtService.saveType('ENTERPRISE')
           this.context.commit(Mutations.SET_AUTH, data);
         }
       })
       .catch(({ response }) => {
         if(response){
           if(response.data.mostrarMensaje == 1){
             this.context.commit(Mutations.SET_ERROR, [response.data.data.mostrarMensaje, response.data.message]);
           }else{
             this.context.commit(Mutations.SET_ERROR, ['0', response.data.message]);
           }
           reject(response);
         }
       });
   });
 }

//  @Action
//  [Actions.LOGOUT]() {
//    this.context.commit(Mutations.PURGE_AUTH);
//  }

 @Action
 [Actions.LOGOUT]() {
  return new Promise((resolve, reject) => {
   // Primero purgar el estado de autenticación
   this.context.commit(Mutations.PURGE_AUTH);

   // Luego limpiar todo el localStorage antes de la llamada al backend
   localStorage.clear();

   // Limpiar cookies
   document.cookie = `token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
   document.cookie = `token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=${window.location.hostname};`;

   // Llamar al backend para cerrar sesión en el servidor
   ApiService.get("/seguridad/userLogout")
     .then(({ data }) => {
       resolve(data);
     })
     .catch((error) => {
       // Incluso si hay error, continuar con el logout
       console.warn("Error al cerrar sesión en el servidor:", error);
       resolve({});
     });
 });
 }

 @Action
 [Actions.REGISTER](credentials) {
   return ApiService.post("register", credentials)
     .then(({ data } : any) => {
       this.context.commit(Mutations.SET_AUTH, data);
     })
     .catch(({ response }) => {
       this.context.commit(Mutations.SET_ERROR, response.data.errors);
     });
 }

 @Action
 [Actions.FORGOT_PASSWORD](payload) {

   const params =
   {
     "FROM": "no-reply@turnmyapp.com",
     "TO": payload.email,
     "SUBJECT": "Se me ha olvidado la contraseña",
     "TEXT": "Este es un correo para restablecer la contraseña \n Su nueva contraseña es:   "
   };
   return new Promise((resolve, reject) => {
     ApiService.post("/seguridad/userForgotPassword", params)
       .then(({ data } : any) => {
         resolve(data);
       })
       .catch(({ response }) => {
          reject(response);
          this.context.commit(Mutations.SET_ERROR, response.data.message);
       });
   });
 }

 @Action
 [Actions.VERIFY_AUTH]() {
   const uuid = JwtService.getToken()
   if (uuid) {
     return new Promise((resolve, reject) => {
       const url = (JwtService.getTYPE() == 'AGENCIA') ? '/seguridad/getUserByUuid' : '/seguridad/usersEnterpriseById';
       ApiService.get(url + '?UUID='+ JwtService.getToken())
         .then(({ data }) => {
          // ajuste para que funcione con la respuesta de la api de tfsm
          const userEnterpriseKey = process.env.VUE_APP_WHOSE_IS == "tfsm" ? 'result' : 'recordset';

          //  console.log('🚀 ~ AuthModule ~ .then ~ data:', data.data.result[0])
           if(JwtService.getTYPE() == 'AGENCIA'){
             const params = {
              data:{
                 userData : {...data.data.result[0], UUID: uuid}
               }
             }
             this.context.commit(Mutations.SET_AUTH, params);
             resolve(data);
            }else{
              const params = {
               data:{
                  userData : {...data.data[`${userEnterpriseKey}`][0], UUID: uuid}
                }
              }
              this.context.commit(Mutations.SET_AUTH, params);
              resolve(data);
           }
         })
         .catch(({ response }) => {
          localStorage.clear();
           reject(response);
           this.context.commit(Mutations.SET_ERROR, response.data.errors);
           this.context.commit(Mutations.PURGE_AUTH);
         });
     });
   } else {
     this.context.commit(Mutations.PURGE_AUTH);
   }
 }

 /**
  * method CheckPermissions
  * variables
  * module: String (Module name that check permissions)
  * permission: String (Permission name)
  * return
  * variable boolean (True if it has permissions or false if hasn't)
  */
 @Action
 async [Actions.CHECK_PERMISSIONS](payload){
   if (JwtService.getToken()) {


    const permisos = await JwtService.getPerm(payload.modulo);
     //return true
     const params = {
       uuid: payload.uuid,
       modulo: payload.modulo,
       permiso: payload.permiso,
       type_user: payload.type_user
     };
     if(payload.modulo == "security-access" && payload.type_user == "USERS"){
      return false;
     } else if (permisos){
      const permiso = permisos?.some((permiso) => permiso[0] == payload.permiso);

      return permiso
     }
     return false;

 }
}

 // @Action
 // [Actions.UPDATE_USER](payload) {
 //   ApiService.setHeader();
 //   return new Promise<void>((resolve, reject) => {
 //     ApiService.post("update_user", payload)
 //       .then(({ data }) => {
 //         this.context.commit(Mutations.SET_USER, data);
 //         resolve();
 //       })
 //       .catch(({ response }) => {
 //         this.context.commit(Mutations.SET_ERROR, response.data.errors);
 //         reject();
 //       });
 //   });
 // }
}
